import * as yup from 'yup'
import helpers from 'helpers'
import constants from 'constants/index'

const schema = yup.object().shape({
  international: yup.boolean().required(),
  simplifiedRegister: yup.boolean(),
  document: yup
    .mixed()
    .test('fileType', 'Somente arquivos XLSX são permitidos', (value) =>
      helpers.validates.file.type(
        [constants.validations.MIME_TYP_VALIDATION.xlsx],
        value,
      ),
    )
    .required(),
  date: yup
    .date()
    .nullable()
    .typeError('Preencha uma data válida')
    .when('simplifiedRegister', {
      is: true,
      then: yup.date().nullable().typeError('Preencha uma data válida'),
      otherwise: yup.date().required().typeError('Preencha uma data válida'),
    }),
  endDate: yup
    .date()
    .nullable()
    .typeError('Preencha uma data válida')
    .min(
      yup.ref('date'),
      'A data de término deve ser igual ou posterior à data de início',
    )
    .when('simplifiedRegister', {
      is: true,
      then: yup.date().nullable().typeError('Preencha uma data válida'),
      otherwise: yup.date().required().typeError('Preencha uma data válida'),
    }),
})

export default schema
